import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import ErrorStackParser from 'error-stack-parser';

import logger from '../util/logger';

export default function (ComposedComponent) {
  class ErrorBoundary extends Component {
    static propTypes = {
      location: PropTypes.object.isRequired,
    };

    constructor(props) {
      super(props);
    }

    componentDidMount() {
      logger.setup();
    }

    componentDidCatch(error, info) {
      const params = { error, info, stackframes: ErrorStackParser.parse(error) };
      logger.report(params);
      console.error(error, info);
      this.props.router.replace('/500');
    }

    render() {
      return <ComposedComponent {...this.props} />;
    }
  }

  return withRouter(ErrorBoundary);
}
